export default function isEmptyHTMLMessage(str) {
  return (
    !str ||
    !str?.length ||
    str === '<div><div class="slate-div"></div></div>' ||
    str === '<div></div>'
  );
}
